export const CREATE_HOTEL_REQUEST = 'CREATE_HOTEL_REQUEST';
export const CREATE_HOTEL_SUCCESS = 'CREATE_HOTEL_SUCCESS';
export const CREATE_HOTEL_FAIL = 'CREATE_HOTEL_FAIL';
export const CREATE_HOTEL_RESET = 'CREATE_HOTEL_RESET';

export const GET_HOTELS_REQUEST = 'GET_HOTELS_REQUEST';
export const GET_HOTELS_SUCCESS = 'GET_HOTELS_SUCCESS';
export const GET_HOTELS_FAIL = 'GET_HOTELS_FAIL';

export const GET_HOTELS_PORTAL_REQUEST = 'GET_HOTELS_PORTAL_REQUEST';
export const GET_HOTELS_PORTAL_SUCCESS = 'GET_HOTELS_PORTAL_SUCCESS';
export const GET_HOTELS_PORTAL_FAIL = 'GET_HOTELS_PORTAL_FAIL';

export const GET_HOTELS_WEBSITE_REQUEST = 'GET_HOTELS_WEBSITE_REQUEST';
export const GET_HOTELS_WEBSITE_SUCCESS = 'GET_HOTELS_WEBSITE_SUCCESS';
export const GET_HOTELS_WEBSITE_FAIL = 'GET_HOTELS_WEBSITE_FAIL';

export const GET_HOTEL_REQUEST = 'GET_HOTEL_REQUEST';
export const GET_HOTEL_SUCCESS = 'GET_HOTEL_SUCCESS';
export const GET_HOTEL_FAIL = 'GET_HOTEL_FAIL';

export const UPDATE_HOTEL_REQUEST = 'UPDATE_HOTEL_REQUEST';
export const UPDATE_HOTEL_SUCCESS = 'UPDATE_HOTEL_SUCCESS';
export const UPDATE_HOTEL_FAIL = 'UPDATE_HOTEL_FAIL';
export const UPDATE_HOTEL_RESET = 'UPDATE_HOTEL_RESET';

export const HIDE_HOTEL_FOR_WEB_REQUEST = 'HIDE_HOTEL_FOR_WEB_REQUEST';
export const HIDE_HOTEL_FOR_WEB_SUCCESS = 'HIDE_HOTEL_FOR_WEB_SUCCESS';
export const HIDE_HOTEL_FOR_WEB_FAIL = 'HIDE_HOTEL_FOR_WEB_FAIL';
export const HIDE_HOTEL_FOR_WEB_RESET = 'HIDE_HOTEL_FOR_WEB_RESET';

export const HIDE_HOTEL_FOR_PORTAL_REQUEST = 'HIDE_HOTEL_FOR_PORTAL_REQUEST';
export const HIDE_HOTEL_FOR_PORTAL_SUCCESS = 'HIDE_HOTEL_FOR_PORTAL_SUCCESS';
export const HIDE_HOTEL_FOR_PORTAL_FAIL = 'HIDE_HOTEL_FOR_PORTAL_FAIL';
export const HIDE_HOTEL_FOR_PORTAL_RESET = 'HIDE_HOTEL_FOR_PORTAL_RESET';

export const CLEAR_ERROR = 'CLEAR_ERROR';
